import React from "react";
import { useNavigate } from "react-router-dom";

function PaymentInstruction() {
  const navigate = useNavigate();

  return (
    <div>
      {/* Header with Back Button */}
      <div className="valign-wrapper gap-1">
        <span
          className="material-icons-outlined pointer"
          onClick={() => navigate(-1)}
        >
          arrow_back
        </span>
        <h4>Payment Instructions</h4>
      </div>
      <h5 className="flex justify-center">How to Make a Payment</h5>
      <div className="valign-wrapper justify-center column gap-10px">
        <p
          className="font-18px orange white-text"
          style={{ padding: "5px 15px", borderRadius: "8px" }}
        >
          To make a payment using{" "}
          <span className="cercle-purple-text">Google Pay</span>, follow these
          steps:
        </p>
        <h5>
          Step 1: Open the Google Pay app → Tap on{" "}
          <strong>"Bank Transfer"</strong> → Enter the recipient's Bank Account
          Number and IFSC Code.
        </h5>
        <div className="valign-wrapper justify-center gap-3 flex-wrap">
          <img
            src={`${process.env.PUBLIC_URL}/images/help-step-1.png`}
            alt="Google Pay Step 1"
          />
          <img
            src={`${process.env.PUBLIC_URL}/images/help-step-2.png`}
            alt="Google Pay Step 2"
          />
        </div>
        <p className="font-14px">
          In most apps, this option is listed as <strong>"To Account"</strong>{" "}
          or <strong>"Bank Transfer"</strong>.
        </p>
      </div>
      <div className="mt-1 valign-wrapper justify-center column gap-10px">
        <h5>
          Step 2: Enter the Amount → Optionally add Remarks using{" "}
          <strong>"Add a note"</strong> → Tap on the Arrow icon → Enter your UPI
          PIN to complete the payment.
        </h5>
        <div className="valign-wrapper justify-center gap-3 flex-wrap">
          <img
            src={`${process.env.PUBLIC_URL}/images/help-step-3.png`}
            alt="Google Pay Step 3"
          />
          <img
            src={`${process.env.PUBLIC_URL}/images/help-step-4.png`}
            alt="Google Pay Step 4"
          />
        </div>
      </div>

      <div className="valign-wrapper justify-center column gap-10px mt-3">
        <p
          className="font-18px orange white-text"
          style={{ padding: "5px 15px", borderRadius: "8px" }}
        >
          To make a payment using{" "}
          <span className="cercle-purple-text">Phone Pay</span>, follow these
          steps:
        </p>
        <h5>
          Step 1: Open phone pay App → Click on To Bank/UPI Id option → Add
          Beneficiary Account → Select Your Bank → Enter your Account number and
          IFSC → Click next Enter.
        </h5>
        <div className="valign-wrapper justify-center flex-wrap">
          <img
            src={`${process.env.PUBLIC_URL}/images/phelp-step-1.png`}
            alt="phone Pay Step 1"
          />
          <img
            src={`${process.env.PUBLIC_URL}/images/phelp-step-2.png`}
            alt="phone Pay Step 2"
          />
          <img
            src={`${process.env.PUBLIC_URL}/images/phelp-step-3.png`}
            alt="phone Pay Step 3"
          />
          <img
            src={`${process.env.PUBLIC_URL}/images/phelp-step-4.png`}
            alt="phone Pay Step 4"
          />
        </div>
        <p className="font-14px">
          In most apps, this option is listed as <strong>"To Account"</strong>{" "}
          or <strong>"Bank Transfer"</strong>.
        </p>
      </div>
      <div className="mt-1 valign-wrapper justify-center column gap-10px">
        <h5>
          Step 2: Enter Bank account details → Click on Proceed to Pay → Enter
          Amount → If payer wants to send Remarks, click on Add Transaction Note
          → Click Pay button and enter UPI PIN to complete the payment.
        </h5>
        <div className="valign-wrapper justify-center gap-1 flex-wrap">
          <img
            src={`${process.env.PUBLIC_URL}/images/phelp-step-5.png`}
            alt="phone Pay Step 5"
          />
          <img
            src={`${process.env.PUBLIC_URL}/images/phelp-step-6.png`}
            alt="phone Pay Step 6"
          />
          <img
            src={`${process.env.PUBLIC_URL}/images/phelp-step-7.png`}
            alt="phone Pay Step 7"
          />
        </div>
      </div>
    </div>
  );
}

export default PaymentInstruction;
